import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { colorsButton, grayScale } from 'app/colors';
import Button, { type ButtonProps } from '__components/Button';
import { borderRadii } from 'app/spacing';
import { truncateCss } from 'app/typography';
import { StyledLabelWrapper, StyledLabel } from 'components/Kizen/Input/styles';

// export const AnchorButton = styled.a`
export const AnchorButton = styled(Button)<
  ButtonProps & { selected?: boolean }
>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${borderRadii.small};
  width: 100%;
  background-color: ${grayScale.white};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    color: ${grayScale.dark};
    background-color: ${grayScale.white};
  }
  height: 36px;
  lineheight: 34px;
  margin: 10px 0 5px 0;
  letter-spacing: unset;
  ${({ selected }) =>
    selected
      ? css`
          border: solid 1px ${colorsButton.blue.hover};
          color: ${grayScale.dark};
          background-color: ${grayScale.white};
          > span {
            cursor: default;
          }
        `
      : css`
          border: solid 1px ${grayScale.medium};
          color: ${grayScale.dark};
        `}
  &:hover {
    border: solid 1px ${colorsButton.blue.hover};
    color: ${grayScale.dark};
    background-color: ${grayScale.white};
  }
  > span {
    margin: 0 10px;
    font-size: 14px;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    ${truncateCss};
  }
`;

export const MfaCheckBoxWrapper = styled(StyledLabelWrapper)`
  margin-top: 20px;
  margin-bottom: 20px;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const MfaCheckBoxLabel = styled(StyledLabel)`
  margin: 0 5px 0 0;
  display: flex;
  align-items: center;
`;

export const MfaCheckBoxIconWrapper = styled(StyledLabel)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0px;
`;

// This was created to match the styling of <KizenTypography type="link" />.
// The original implementation used a link variant of KizenTypography without
// an href. This wasn't right and react-router-dom throws an error. This keeps
// the page looking the same without altering the page-wide css too much.
export const TextButton = styled(Button)<ButtonProps>`
  &&& {
    font-size: 14px;
    display: flex;
    letter-spacing: unset;
    padding-top: 5px;

    div:hover {
      text-decoration: underline;
    }
  }
`;

export const LinkButton = styled(TextButton)`
  &&& {
    height: 1em;
    width: 100%;
    justify-content: flex-end;
    padding: 0;
  }
`;
